import React, { useState } from 'react'
import {
  Row,
  Col,
  Card,
  Button,
  Alert,
  Modal
} from "react-bootstrap";
import con1 from "../assets/panelImages/Survey/Consumer1.jpg"
import con2 from "../assets/panelImages/Survey/Consumer2.jpg"
import con3 from "../assets/panelImages/Survey/Consumer3.jpg"
import con4 from "../assets/panelImages/Survey/Consumer4.jpg"
import timeico from "../assets/panelImages/dashboard/clock.svg"
import pointsico from "../assets/panelImages/dashboard/pts.svg"
const surveys = [
  {
    image: con1,
    title: "Consumer",
    duration: "20 Mins",
    points: 1000,
  },
  {
    image: con2,
    title: "Consumer",
    duration: "10 Mins",
    points: 1000,
  },
  {
    image: con3,
    title: "Consumer",
    duration: "15 Mins",
    points: 1000,
  },
  {
    image: con4,
    title: "Consumer",
    duration: "20 Mins",
    points: 1000,
  },
];

const Dashboard = () => {
  const [showEmailModal, setShowEmailModal] = useState(true);
  const handleShowEmailModal = () => setShowEmailModal(true);
  const handleCloseEmailModal = () => {
    setShowEmailModal(false);
  };
  return (<>
    <h2 className="welcome-text text-center text-md-start">Welcome back, Todd!</h2>
    <Alert variant="success" className="email-alert d-flex flex-column flex-md-row justify-content-between align-items-center">
      <div className="text-center text-md-start mb-2 mb-md-0 alert-text">
        Looks like you missed verifying your email account.<br />Hurry! you get 1000 points once you verify.
      </div>
      <Button className="email-alert-btn" onClick={handleShowEmailModal}>Get started</Button>
    </Alert>
    <h3 className="mt-4 text-center text-md-start">Available Surveys</h3>
    <Row>
      {surveys.map((survey) => (
        <Col xs={12} sm={6} md={3} key={survey.id} className="my-2">
          <Card className='survey-card'>
            <Card.Img variant="top" src={survey.image} />
            <Card.Body className="text-center">
              <Card.Title>{survey.title}</Card.Title>
              <Card.Text>
                <img src={timeico} className='surveycard-icons' alt='duration' /> {survey.duration} |  <img src={pointsico} className='surveycard-icons' alt='points' />{survey.points} Pts
              </Card.Text>
              <Button variant="success" className='survey-btn'>Start</Button>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
    <Modal className='EmailReminder' show={showEmailModal} onHide={handleCloseEmailModal} centered>
      {/* <Modal.Header closeButton>
      </Modal.Header> */}
      <Modal.Body style={{textAlign:"center"}}>
        <h3 className="title">Fill your personal details to get exciting gift offers!</h3>
        <p>Hurry! you get 1000 points once you verify. Please check your inbox and click the link given in the account verification email sent to your registered email account.<br/> Didn’t get verification email yet?</p>

        <Button className="survey-btn btn btn-success" onClick={handleCloseEmailModal}>Resend Email</Button>
      </Modal.Body>
    </Modal>
  </>

  )
}

export default Dashboard